import React, { useContext, useEffect, useState } from "react";
import { Dropdown, Form } from "react-bootstrap";
import FlagIconFactory from 'react-flag-icon-css';
import { CurrentLanguageContext } from "../contexts/currentLanguage";

const FlagIcon = FlagIconFactory(React, { useCssModules: false })

export function LanguageChoiceDropdown() {

    const [countries] = useState<{ id: string, code: string, title: string }[]>([
        { id: 'fr', code: 'fr', title: 'Français' },
        { id: "en", code: 'us', title: 'English' },
    ]);
    const [toggleContents, setToggleContents] = useState<JSX.Element>(<>

    </>);

    const { currentLanguage, setCurrentLanguage } = useContext(CurrentLanguageContext)



    useEffect(() => {
        if (currentLanguage) {
            const item = countries.find(
                ({ id }) => currentLanguage === id
            );
            if (!item) {
                return
            }

            setToggleContents(
                <>
                    <FlagIcon className="fs-2" code={item.code} /> {item.title}
                </>
            );
        }

    }, [currentLanguage])


    return (
        <div>
            <Form>
                <Dropdown
                    onSelect={(eventKey: string | null) => {
                        const item = countries.find(
                            ({ code }) => eventKey === code
                        );
                        if (!item) {
                            return
                        }

                        setCurrentLanguage(item.id);
                        setToggleContents(
                            <>
                                <FlagIcon className="fs-2" code={item.code} />
                                {item.title}
                            </>
                        );
                    }}
                >
                    <Dropdown.Toggle
                        variant="none"
                        id="dropdown-flags"
                        className="d-flex align-items-center gap-4 text-left text-white p-0 py-4 w-full"
                        style={{ backgroundColor: "#1b4b60" }}
                    >
                        {toggleContents}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        {countries.map(({ code, title }) => (
                            <Dropdown.Item className="py-4 d-flex align-items-center gap-4" active={code === currentLanguage} key={code} eventKey={code}>
                                <FlagIcon className="fs-2" code={code} /> {title}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            </Form>
        </div>
    );
}